export default {
    name: "Air Freight",
    meta: {
        icon: "flight",
        expanded: true,
        auth: true
    },
    departmentName: "Air Freight",
    finalPagePermision: "",
    children: [

        {
            name: "Air Export Details",
            permissionName: 'Air Export',
            keywords: ['Air Export', 'Air Freight', 'Air Export Details'],
            path: "/airFreight/viewAirFF",
            meta: {
                icon: "flight",
                auth: true
            },
            component: require("../component/airFreight/viewAirFF.vue"),
            finalPagePermision: "Air Export",


        },
        {
            name: "Air Import Details",
            permissionName: 'Air Import',
            keywords: ['Air Import', 'Air Freight', 'Air Import Details'],
            path: "/airImport/viewAirImportDetails",
            meta: {
                icon: "flight",
                auth: true
            },
            component: require("../component/airImport/viewAirImportDetails.vue"),
            finalPagePermision: "Air Import",
        },

        {
            name: "Air CC Export Details",
            permissionName: 'Air Import',
            keywords: ['Air Import', 'Air Freight', 'Air Import Details'],
            path: "/airImport/viewAirCC",
            meta: {
                icon: "flight",
                auth: true
            },
            component: require("../component/airFreight/viewAirCCTPT.vue"),
            finalPagePermision: "Air Import",
        },
        {
            name: "Air TPT Export Details",
            permissionName: 'Air Import',
            keywords: ['Air Import', 'Air Freight', 'Air Import Details'],
            path: "/airImport/viewAirTPT",
            meta: {
                icon: "flight",
                auth: true
            },
            component: require("../component/airFreight/viewAirCCTPT.vue"),
            finalPagePermision: "Air Import",
        },
        {
            name: "Air Export Reports",
            permissionName: 'Air Export',
            keywords: ['Air Export', 'Air Freight', 'Air Export Reports'],
            path: "/reports/airExportReports",
            meta: {
                icon: "flight",
                auth: true
            },
            component: require("../component/reports/airExportReports.vue"),
            finalPagePermision: "Air Export",


        },

        {
            name: "Air Import Reports",
            permissionName: 'Air Import',
            keywords: ['Air Import', 'Air Freight', 'Air Import Reports'],
            path: "/reports/airImportReports",
            meta: {
                icon: "flight",
                auth: true
            },
            component: require("../component/reports/airImportReports.vue"),
            finalPagePermision: "Air Import",
        },



    ]
};


// WEBPACK FOOTER //
// ./src/sidebar/airFreight.js